import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class AdSubjectService {
    private selectedOffer$ = new BehaviorSubject<any>(null);
    private firstOfferRegistered$ = new BehaviorSubject<boolean>(false); // Bandera para la primera oferta registrada

    setSelectedOffer(offer: any) {
        this.selectedOffer$.next(offer);
    }

    getSelectedOffer() {
        return this.selectedOffer$.value;
    }

    setFirstOfferRegistered(value: boolean) {
        this.firstOfferRegistered$.next(value);
    }

    isFirstOfferRegistered() {
        return this.firstOfferRegistered$.value;
    }
}
